'use es6';

export var COS_TEMPLATE = 'COS_TEMPLATE';
export var CUSTOM_MODULE = 'CUSTOM_MODULE';
export var PACK = 'PACK';
export var CMS_THEME = 'CMS_THEME';
export var APP = 'APP';